/** @file 0..1 progress of a document curve over a segment, as core samples multi-component channels. */
import { compileCurve } from '@pose2d/compiler/compile/compileCurve';
import type { Curve } from '@pose2d/format/types';
import { evalCubicBezier } from '@pose2d/math/bezier';

/** Progress at normalized segment time u: linear u, stepped 0, bezier through compileCurve(curve, 0, 1) (§6.4). */
export function curveProgress(curve: Curve | undefined, u: number): number {
  const code = compileCurve(curve, 0, 1);
  if (code === 0) return u;
  if (code === 1) return 0;
  return evalCubicBezier(code[0], code[1], code[2], code[3], 0, 1, u);
}
